export default "/assets/images/reading-girl-placeholder.a4048b827898d211.jpg";